export default "__VITE_ASSET__DafLx1Ft__"